import React, { createContext, useContext, useEffect, useState } from 'react';
import { IWidget } from '../components/widgets/WidgetBar';
import RecentEmails from '../components/widgets/RecentEmails/RecentEmails';
import Calendar from '../components/widgets/calendar/Calendar';
import MyProviderData from '../components/widgets/MyProviderData/MyProviderData';
import Openings from '../components/widgets/Openings/Openings';
import ServiceRequestWidget from '../components/widgets/ServiceRequest/ServiceRequestWidget';
import { CurrentUserContext } from './CurrentUserContext';
import { AccessControl, PermissionKey } from '@/types/common/accessControl';

interface WidgetContextType {
  widgets: IWidget[];
  openWidget: IWidget | null;
  setOpenWidget: (widget: IWidget | null) => void;
}

const WidgetContext = createContext<WidgetContextType | null>(null);

export const WidgetProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [openWidget, setOpenWidget] = useState<IWidget | null>(null);
  const [widgets, setWidgets] = useState<IWidget[]>([])
  const { accessControl } = useContext(CurrentUserContext);



  useEffect(() => {
    function getViewableWidgets(ac: AccessControl): IWidget[] {
      let widgetList: IWidget[] = [];
      const widgetControl: { permName: PermissionKey, widget: IWidget }[] =
        [
          {
            permName: 'widget_mail',
            widget: { icon: 'Mail', title: 'Recent Emails', content: <RecentEmails autoRefreshIntervalMs={60000} />, size: 'medium' }
          },
          {
            permName: 'widget_provider_data',
            widget: { icon: 'Touch', title: 'Provider Data', content: <MyProviderData />, size: 'large' }
          },
          {
            permName: 'widget_calendar',
            widget: { icon: 'Calendar', title: 'Calendar', content: <Calendar />, size: 'large' }
          },
          {
            permName: 'widget_openings',
            widget: { icon: 'Users', title: 'Openings', content: <Openings />, size: 'large' }
          },
          {
            permName: 'widget_service_request',
            widget: { icon: 'ClipboardList', title: 'Service Request', content: <ServiceRequestWidget />, size: 'large' }
          }
        ]
      widgetControl.forEach((ctrl) => {
        if (accessControl.canRead(ctrl.permName)) {
          widgetList.push(ctrl.widget);
        }
      })
      return widgetList;
    }
    setWidgets(getViewableWidgets(accessControl));
  }, [accessControl])


  return (
    <WidgetContext.Provider value={{ widgets, openWidget, setOpenWidget }}>
      {children}
    </WidgetContext.Provider>
  );
};

export const useWidgets = () => {
  const ctx = useContext(WidgetContext);
  if (!ctx) throw new Error('useWidgets must be used within a WidgetProvider');
  return ctx;
};
